module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/2WPmXn0Zu0kYws2IaqYyge-78abf9004de4e3c8ef6a332507b5b445.jpg";